<template>
  <div class="section-abstract-header">Informations juridiques et affiliations</div>
  <div class="section-abstract mb-1">
    <v-row class="ma-0 abstract-row"
           @click="openSection('SectionEtablissementInformationJuridiqueExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Informations juridiques</div>
        <div class="section-abstract-grid"
             style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">SIRET</div>
            <div :class="etablissement.siret ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.siret || missingLabel() }}
              <v-icon v-if="etablissement.siret" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(etablissement.siret, 0)">
                {{ copiedField === 0 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Code APE</div>
            <div :class="etablissement.brancheCode ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.brancheCode || missingLabel() }}
              <v-icon v-if="etablissement.brancheCode" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(etablissement.brancheCode, 1)">
                {{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">Convention collective</div>
            <div :class="etablissement.conventionCode ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.conventionCode || missingLabel() }}
              <v-icon v-if="etablissement.conventionCode" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(etablissement.conventionCode, 2)">
                {{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Licence entrepreneur spectacle vivant</div>
            <div :class="etablissement.licenceSpectacle ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.licenceSpectacle || missingLabel() }}
              <v-icon v-if="etablissement.licenceSpectacle" class="pl-2" color="rgb(var(--v-theme-secondary60))"
                      size="14" @click.stop="copyText(etablissement.licenceSpectacle, 3)">
                {{ copiedField === 3 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">fas fa-chevron-right</v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row"
           @click="openSection('SectionEtablissementAffliationExtend', 'etablissement', false)">
      <v-col>
        <div class="section-abstract-title">Affiliations</div>
        <div class="section-abstract-grid"
             style="display:grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">N° URSSAF</div>
            <div :class="etablissement.urssaf ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.urssaf || missingLabel() }}
              <v-icon v-if="etablissement.urssaf" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(etablissement.urssaf, 4)">
                {{ copiedField === 4 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">N° Congés Spectacle</div>
            <div :class="etablissement.congesSpec ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.congesSpec || missingLabel() }}
              <v-icon v-if="etablissement.congesSpec" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(etablissement.congesSpec, 5)">
                {{ copiedField === 5 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-label pt-2">N° Affiliation France Travail</div>
            <div :class="etablissement.poleEmploiAffiliation ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.poleEmploiAffiliation || missingLabel() }}
              <v-icon v-if="etablissement.poleEmploiAffiliation" class="pl-2" color="rgb(var(--v-theme-secondary60))"
                      size="14" @click.stop="copyText(etablissement.poleEmploiAffiliation, 6)">
                {{ copiedField === 6 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
          <div class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 2 / span 1;">
            <div class="section-abstract-label pt-2">Caisse de retraite complémentaire</div>
            <div
                :class="etablissement.retraiteComplementaireNom ? 'section-abstract-value' : 'section-abstract-missing'">
              {{ etablissement.retraiteComplementaireNom || missingLabel() }}
              <v-icon v-if="etablissement.retraiteComplementaireNom" class="pl-2"
                      color="rgb(var(--v-theme-secondary60))" size="14"
                      @click.stop="copyText(etablissement.retraiteComplementaireNom, 7)">
                {{ copiedField === 7 ? 'fas fa-check' : 'fas fa-copy' }}
              </v-icon>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="1" class="align-content-center align-items-center">
        <v-icon class="chevron-right">fas fa-chevron-right</v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import SectionEtablissementJuridiqueAbstract from "@/generated/sections/SectionEtablissementJuridiqueAbstract.vue";

export default defineComponent({
  components: {},
  extends: SectionEtablissementJuridiqueAbstract,
  methods: {
    missingLabel(): string {
      return 'Informations manquantes';
    }
  }
})
</script>